import { render, staticRenderFns } from "./room-item.vue?vue&type=template&id=953a4566&scoped=true&"
import script from "./room-item.vue?vue&type=script&lang=js&"
export * from "./room-item.vue?vue&type=script&lang=js&"
import style0 from "./room-item.vue?vue&type=style&index=0&id=953a4566&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953a4566",
  null
  
)

export default component.exports